import styled from "@emotion/styled";
import InformationIcon from "../../../components/icons/InformationIcon";
import Popup from "../../../components/popups/Popup";
import { COLOR_APP_TEXT } from "../../../components/theme";
import { Paragraph } from "../../../components/typography/Paragraph";

const Container = styled.div`
  text-align: left;
  > * {
    margin-bottom: 24px;
  }
`;

const A = styled.a`
  text-decoration: underline;
  color: ${COLOR_APP_TEXT};
`;

const OL = styled.ol`
  list-style-type: decimal;
  padding-left: 16px;
`;

const LI = styled.li`
  text-align: left;
  margin-bottom: 16px;
`;

const Strong = styled.strong`
  font-weight: 600;
`;

export const SevenDayRulePopup = ({ onConfirm }: { onConfirm: () => void }) => {
  return (
    <Popup
      title="It's not you, it's California Law."
      icon={<InformationIcon color={COLOR_APP_TEXT} />}
      description={
        <Container>
          <Paragraph textAlign="left">
            Your wedding date is within the next 7 days. That means we&apos;re
            legally unable to help you create a prenuptial agreement right now
            due to{" "}
            <A href="https://app.intercom.com/a/apps/seizs4ey/knowledge-hub/all-content?activeContentId=6338564&activeContentType=article&editorMode=view&search=7%20day%20rule">
              California law&apos;s 7-day rule requirement.
            </A>
          </Paragraph>
          <Paragraph textAlign="left">
            However, you&apos;ve got two options:
          </Paragraph>
          <OL>
            <LI>
              <Paragraph textAlign="left">
                <Strong>Move your wedding date back:</Strong> <br /> If
                you&apos;re open to pushing your ceremony out just a bit,
                you&apos;ll still be able to move forward with a prenup.
              </Paragraph>
            </LI>
            <LI>
              <Paragraph textAlign="left">
                <Strong>Join the Postnup Waitlist:</Strong> <br /> If
                rescheduling isn&apos;t an option, no worries. You can create a
                postnuptial agreement after the wedding instead. It&apos;s
                similar to a prenup—just done after you say, &lsquo;I do.&rsquo;
                We know this might not be what you were expecting, but
                we&apos;re here to help you protect your future the right way.
              </Paragraph>
            </LI>
          </OL>
          <Paragraph textAlign="left">Which would you like to do?</Paragraph>
        </Container>
      }
      buttons={{
        confirmText: "Reschedule my marriage date",
        cancelText: "Join postnup waitlist",
        onConfirm,
        onCancel: () => {
          window.open(
            "https://airtable.com/app2ZKE3j9r7Q7URH/shrX5lImXa4zqAdDD",
            "_blank",
          );
        },
      }}
    />
  );
};
